
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { ObjectType, SportType } from '@/@types/graphql-types';
import { SnowplowSportContext } from '@/helpers/tracking/providers';
import { SportPageType } from '@/interfaces/sport-graphql';

@Component({ name: 'EventOverview' })
export default class EventOverview extends Vue {
	@Prop() startDateTime: Date | null;
	@Prop() sport: SportType;
	@Prop() competitionId: number | undefined;

	countdown = {
		days: '00',
		hours: '00',
		minutes: '00',
		seconds: '00',
		isOver: true,
	};

	serverPrefetch() {
		// Prevent CLS when countdown loads
		this.calculateCountdown();
	}

	mounted() {
		// Prevent countdown snapping to 00 when page mounts
		this.calculateCountdown();

		const id = setInterval(() => this.calculateCountdown(), 1000);
		this.$on('hook:deactivated', () => clearInterval(id));
	}

	// ! Hacky temp fix. Would be good to replace this with a fullPath delivered by the API in the Competition object
	get competitionPagePath() {
		const fullPath = this.$route.fullPath.toString();
		return fullPath.substring(0, fullPath.lastIndexOf('/'));
	}

	calculateCountdown() {
		if (this.startDateTime == null) return;

		const delta = new Date(this.startDateTime).getTime() - new Date().getTime();
		this.countdown = {
			days: formatNumber(delta / (1000 * 60 * 60 * 24)),
			hours: formatNumber((delta % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
			minutes: formatNumber((delta % (1000 * 60 * 60)) / (1000 * 60)),
			seconds: formatNumber((delta % (1000 * 60)) / 1000),
			isOver: delta <= 0,
		};
	}

	trackNavigation() {
		const sportContext = new SnowplowSportContext(this.sport, ObjectType.SportCompetition);
		sportContext.competitionId = this.competitionId;
		TrackingHelper.trackEvent(
			'userinteraction',
			{ action: 'competition_clicked', label: SportPageType.SportEvent, property: 'header', useLastRoute: true },
			[sportContext]
		);
	}
}

const formatNumber = (n: number) => String(Math.floor(n)).padStart(2, '0');
